var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"tile":"","ripple":false,"flat":"","aria-label":_vm.$t('TOP_BAR.BUTTON.CONTRAST')},nativeOn:{"click":function($event){return _vm.onContrastChange($event)}}},[_c('v-icon',[_vm._v("mdi-invert-colors")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }